<template lang="pug">
.admin-home.d-flex
  .sidebar.scrollable.py-3.pl-3.pr-2
    AdminUserStatPanel(
      :user='user'
      :notificationCount='notificationCount'
    )
    GenericCard.pt-3(size='33')
      MenuItem(title='รายการรออนุมัติ' @click="$router.push('/admin/pending-approval')")
      MenuItem(title='ราคาสินค้าและค่าคอม' @click="$router.push('/admin/price-settings')")
      MenuItem(title='เซลล์และเป้ายอดขาย' @click="$router.push('/admin/seller-records')")
      MenuItem(title='ตั้งค่าพนักงาน' @click="$router.push('/admin/permission-settings')")
      MenuItem(title='พิมพ์รายงาน' @click="$router.push('/admin/print')")
      MenuItem(title='ตั้งค่าบัญชีส่วนตัว' @click="$router.push('/admin/settings')")
      MenuItem(title='ออกจากระบบ' @click="$store.dispatch('logout')")

  .content
    .h-100.py-3.pr-2.pl-0
      //- unpaid, dueToday, backOrder, awaitShipment
      //- .d-flex.flex-wrap(v-if='user.stat')
      //-   StatItem(
      //-     v-for='(title, key) in statFields'
      //-     :key='key'
      //-     :title='title'
      //-     :badgeNumber='user.stat[key].count'
      //-     :value='user.stat[key].total'

      //-     :highlighted='key === selectedStatItem'
      //-     @click='onStatItemSelected(key)'
      //-   )

      //- dueList
      .h-100.scrollable
        AdminPendingApprovalList
        //- template(v-if='selectedStatItem === `pendingOrder`')
        //-   CSPendingOrderList
        //- template(v-else-if='selectedStatItem === `unpaid`')
        //-   CSUnpaidList
        //- template(v-else-if='selectedStatItem === `backOrder`')
        //-   CSBackOrderList
        //- template(v-else-if='selectedStatItem === `awaitShipment`')
        //-   CSAwaitShipmentList
        //- template(v-else)
        //-   GenericCard(size='auto')
        //-     .px-4.py-3
        //-       .text-large {{ selectedStatItem }}

  NotificationPanel(
    style='position: fixed; top: 0; width: 100%'
    @dataLoaded='notifications = $event'
    @itemClicked='showOrderDetail'
  )

</template>

<script>
/* eslint-disable arrow-body-style */
import AdminUserStatPanel from '@/components/_admin/dashboard/AdminUserStatPanel.vue';
import NotificationPanel from '@/components/_dialogs/NotificationPanel.vue';

import AdminPendingApprovalList from '@/components/_admin/dashboard/panels/AdminPendingApprovalList.vue';
// import CSUnpaidList from '@/components/_cs/dashboard/panels/CSUnpaidList.vue';
// import CSBackOrderList from '@/components/_cs/dashboard/panels/CSBackOrderList.vue';
// import CSAwaitShipmentList from '@/components/_cs/dashboard/panels/CSAwaitShipmentList.vue';

export default {
  data: () => ({
    user: {},
    statFields: {
      pendingOrder: 'รายการรออนุมัติ',
      unpaid: 'รายการค้างชำระ',
      backOrder: 'รายการตกค้าง(backorder)',
      awaitShipment: 'รายการรอจัดส่ง',
    },
    selectedStatItem: 'pendingOrder',

    notifications: [],
    notificationCount: null,
  }),
  watch: {
    notifications: {
      deep: true,
      handler() {
        // recalculate notificationCount
        this.notificationCount = this.notifications.reduce((total, notif) => {
          if (notif.read === 0) return total + 1;
          return total;
        }, 0);
      },
    },
  },
  mounted() {
    this.loadCurrentUser();
  },
  methods: {
    async showOrderDetail(notification) {
      // alert(JSON.stringify(notification));
      const { order_id: orderId } = notification;

      try {
        const res = await this.$api.order.getWithId(orderId);

        this.$router.push({
          name: 'admin.pending-approval', // can't use path, cause it WON'T allow passing hidden params
          params: {
            order: res.data,
            // ...e, // pass everything in, LOL
          },
        });

        console.log(res);
      } catch (e) {
        console.log(e);
      }
    },

    async loadCurrentUser() {
      this.isLoading = true;

      const res = await this.$api.user.myProfile();
      if (res.status === 200) {
        this.user = res.data;
      }

      this.isLoading = false;
    },
    onStatItemSelected(statItemKey) {
      // alert(e);
      this.selectedStatItem = statItemKey;
    },
  },
  components: {
    AdminUserStatPanel,
    NotificationPanel,

    AdminPendingApprovalList,
    // CSUnpaidList,
    // CSBackOrderList,
    // CSAwaitShipmentList,
  },
};
</script>

<style lang="scss">
.admin-home {
  // max-width: 1200px;
  margin: 0 auto;

  .sidebar {
    // ...
  }
  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100vh;

    .generic-card {
      height: 100%;
      .card {
        height: 100%;
      }
    }
  }
  .generic-card {
    // padding-left: 0;
    // padding-bottom: 0;
    padding: 8px;
  }
}
</style>
